function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1904(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40.48,
    height: 28.42,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.736666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 20.24,
    y: 14.21
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28.42,
    width: 40.48,
    height: 33.54,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7266666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 20.24,
    y: 45.19
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 61.96,
    width: 40.48,
    height: 38.84,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.71
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 20.24,
    y: 81.38
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 100.81,
    width: 40.48,
    height: 41.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.782857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 20.24,
    y: 121.485
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 142.15,
    width: 40.48,
    height: 41.41,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.06
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 20.24,
    y: 162.85500000000002
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 183.56,
    width: 40.48,
    height: 41.99,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.746666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 20.24,
    y: 204.555
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 225.55,
    width: 40.48,
    height: 44.43,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.746666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 20.24,
    y: 247.76500000000001
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 269.98,
    width: 40.48,
    height: 44.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.12
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 20.24,
    y: 292.255
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 314.53,
    width: 40.48,
    height: 51.13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.048
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 20.24,
    y: 340.09499999999997
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 365.67,
    width: 40.48,
    height: 51.77,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.096
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 20.24,
    y: 391.555
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 417.44,
    width: 40.48,
    height: 54.28,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.12
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 20.24,
    y: 444.58
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 471.71,
    width: 40.48,
    height: 55.32,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.096
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 20.24,
    y: 499.37
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 527.04,
    width: 40.48,
    height: 56.43,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.06
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 20.24,
    y: 555.255
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 583.47,
    width: 40.48,
    height: 57.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.048
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 20.24,
    y: 612.27
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 641.06,
    width: 40.48,
    height: 58.94,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.782857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 20.24,
    y: 670.53
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.48,
    y: 0,
    width: 48.92,
    height: 50.65,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.435555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.94,
    y: 25.325
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 0,
    width: 49.15,
    height: 50.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.2875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.97500000000001,
    y: 25.325
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.55,
    y: 0,
    width: 49.85,
    height: 50.65,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.308333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.47500000000002,
    y: 25.325
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.4,
    y: 0,
    width: 50.03,
    height: 50.65,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.147142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.41500000000002,
    y: 25.325
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 238.43,
    y: 0,
    width: 50.36,
    height: 50.65,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.196666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 263.61,
    y: 25.325
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.79,
    y: 0,
    width: 56.97,
    height: 50.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0649999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 317.27500000000003,
    y: 25.325
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.76,
    y: 0,
    width: 57.34,
    height: 50.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.441666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.43,
    y: 25.325
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.1,
    y: 0,
    width: 57.39,
    height: 50.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.33125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 431.795,
    y: 25.325
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 460.49,
    y: 0,
    width: 57.81,
    height: 50.65,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.441666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 489.395,
    y: 25.325
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 518.3,
    y: 0,
    width: 57.81,
    height: 50.65,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.627777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 547.2049999999999,
    y: 25.325
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 576.1,
    y: 0,
    width: 61.76,
    height: 50.65,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.129999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 606.98,
    y: 25.325
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 637.86,
    y: 0,
    width: 62.14,
    height: 50.65,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.441666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.9300000000001,
    y: 25.325
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.48,
    y: 50.65,
    width: 60.52,
    height: 52.4,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.763636363636364
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.74,
    y: 76.85
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.48,
    y: 103.05,
    width: 60.52,
    height: 55.13,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.188333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.74,
    y: 130.615
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.48,
    y: 158.18,
    width: 60.52,
    height: 56.25,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.74,
    y: 186.305
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.48,
    y: 214.43,
    width: 60.52,
    height: 57.19,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.437999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.74,
    y: 243.025
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.48,
    y: 271.62,
    width: 60.52,
    height: 57.77,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.628333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.74,
    y: 300.505
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.48,
    y: 329.4,
    width: 60.52,
    height: 58.83,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.805
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.74,
    y: 358.815
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.48,
    y: 388.22,
    width: 60.52,
    height: 59.22,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.74,
    y: 417.83000000000004
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.48,
    y: 447.44,
    width: 60.52,
    height: 61.55,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.104000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.74,
    y: 478.215
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.48,
    y: 508.99,
    width: 60.52,
    height: 63.31,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.501818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.74,
    y: 540.645
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.48,
    y: 572.3,
    width: 60.52,
    height: 63.7,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.086666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.74,
    y: 604.15
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.48,
    y: 635.99,
    width: 60.52,
    height: 64.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.74,
    y: 667.995
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 50.65,
    width: 62.61,
    height: 62.81,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.82625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 132.305,
    y: 82.055
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.6,
    y: 50.65,
    width: 64.11,
    height: 62.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.978888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.655,
    y: 82.055
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.71,
    y: 50.65,
    width: 66.17,
    height: 62.81,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.978888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 260.795,
    y: 82.055
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 293.88,
    y: 50.65,
    width: 66.85,
    height: 62.81,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.972857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 327.305,
    y: 82.055
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360.73,
    y: 50.65,
    width: 67.26,
    height: 62.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.85125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 394.36,
    y: 82.055
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.99,
    y: 50.65,
    width: 67.26,
    height: 62.81,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.85125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.62,
    y: 82.055
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 495.25,
    y: 50.65,
    width: 67.37,
    height: 62.81,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.281000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 528.935,
    y: 82.055
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 562.63,
    y: 50.65,
    width: 68.42,
    height: 62.81,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.468333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 596.84,
    y: 82.055
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 631.05,
    y: 50.65,
    width: 68.95,
    height: 62.81,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.562000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.525,
    y: 82.055
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 113.46,
    width: 71.63,
    height: 61.78,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.296666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.815,
    y: 144.35
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 175.24,
    width: 71.63,
    height: 62.37,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.474
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.815,
    y: 206.425
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 237.61,
    width: 71.63,
    height: 63.29,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.041428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.815,
    y: 269.255
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 300.9,
    width: 71.63,
    height: 64.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.154285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.815,
    y: 332.94
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 364.98,
    width: 71.63,
    height: 64.9,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.271428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.815,
    y: 397.43
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 429.89,
    width: 71.63,
    height: 65.36,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.893333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.815,
    y: 462.57
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 495.25,
    width: 71.63,
    height: 67.83,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.305
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.815,
    y: 529.165
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 563.08,
    width: 71.63,
    height: 68.43,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.1075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.815,
    y: 597.2950000000001
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 631.51,
    width: 71.63,
    height: 68.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.697999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.815,
    y: 665.755
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.63,
    y: 113.46,
    width: 71.43,
    height: 69.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.573333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 208.345,
    y: 148.18
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.06,
    y: 113.46,
    width: 71.94,
    height: 69.44,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.7155555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.03,
    y: 148.18
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 113.46,
    width: 72.38,
    height: 69.44,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.573333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 352.19,
    y: 148.18
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 388.38,
    y: 113.46,
    width: 75.64,
    height: 69.44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.7155555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 426.2,
    y: 148.18
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.02,
    y: 113.46,
    width: 76.28,
    height: 69.44,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.573333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 502.15999999999997,
    y: 148.18
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 540.3,
    y: 113.46,
    width: 78.86,
    height: 69.44,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 579.7299999999999,
    y: 148.18
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619.17,
    y: 113.46,
    width: 80.83,
    height: 69.44,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 659.5849999999999,
    y: 148.18
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.63,
    y: 182.91,
    width: 84.51,
    height: 72.03,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.885,
    y: 218.925
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.63,
    y: 254.94,
    width: 84.51,
    height: 72.75,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.392857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.885,
    y: 291.315
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.63,
    y: 327.69,
    width: 84.51,
    height: 73.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.646
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.885,
    y: 364.305
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.63,
    y: 400.92,
    width: 84.51,
    height: 73.34,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.1675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.885,
    y: 437.59000000000003
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.63,
    y: 474.26,
    width: 84.51,
    height: 74.48,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.885,
    y: 511.5
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.63,
    y: 548.74,
    width: 84.51,
    height: 75.13,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.521666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.885,
    y: 586.3050000000001
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.63,
    y: 623.87,
    width: 84.51,
    height: 76.13,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.6129999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.885,
    y: 661.935
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.14,
    y: 182.91,
    width: 86.74,
    height: 74.91,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.70142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 300.51,
    y: 220.365
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.88,
    y: 182.91,
    width: 87.34,
    height: 74.91,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.7275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 387.55,
    y: 220.365
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 431.22,
    y: 182.91,
    width: 88.28,
    height: 74.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.36375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 475.36,
    y: 220.365
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 519.5,
    y: 182.91,
    width: 89.89,
    height: 74.91,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.70142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 564.445,
    y: 220.365
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 609.39,
    y: 182.91,
    width: 90.61,
    height: 74.91,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.485
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 654.6949999999999,
    y: 220.365
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.14,
    y: 257.81,
    width: 80.89,
    height: 85.02,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.2225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.585,
    y: 300.32
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.14,
    y: 342.83,
    width: 80.89,
    height: 86.07,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.555714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.585,
    y: 385.865
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.14,
    y: 428.89,
    width: 80.89,
    height: 88.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.555714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.585,
    y: 473.15999999999997
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.14,
    y: 517.44,
    width: 80.89,
    height: 89.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.555714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.585,
    y: 562.35
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.14,
    y: 607.26,
    width: 80.89,
    height: 92.74,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.089
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.585,
    y: 653.63
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.03,
    y: 257.81,
    width: 89.5,
    height: 84.34,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.371111111111112
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 382.78,
    y: 299.98
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.53,
    y: 257.81,
    width: 90.28,
    height: 84.34,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.434000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 472.66999999999996,
    y: 299.98
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 517.81,
    y: 257.81,
    width: 91.01,
    height: 84.34,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.868000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 563.3149999999999,
    y: 299.98
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 608.82,
    y: 257.81,
    width: 91.18,
    height: 84.34,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.04857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 654.4100000000001,
    y: 299.98
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.03,
    y: 342.16,
    width: 97.52,
    height: 88.46,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.692
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 386.78999999999996,
    y: 386.39000000000004
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.03,
    y: 430.61,
    width: 97.52,
    height: 88.87,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.695714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 386.78999999999996,
    y: 475.045
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.03,
    y: 519.48,
    width: 97.52,
    height: 88.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.1175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 386.78999999999996,
    y: 563.95
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.03,
    y: 608.42,
    width: 97.52,
    height: 91.58,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.263333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 386.78999999999996,
    y: 654.2099999999999
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 435.54,
    y: 342.16,
    width: 85.57,
    height: 108.38,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.779090909090908
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 478.32500000000005,
    y: 396.35
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.12,
    y: 342.16,
    width: 89.16,
    height: 108.38,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 565.7,
    y: 396.35
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 610.27,
    y: 342.16,
    width: 89.73,
    height: 108.38,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.21625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 655.135,
    y: 396.35
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 435.54,
    y: 450.54,
    width: 121.71,
    height: 80.64,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 496.39500000000004,
    y: 490.86
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 435.54,
    y: 531.18,
    width: 121.71,
    height: 81.66,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 496.39500000000004,
    y: 572.01
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 435.54,
    y: 612.84,
    width: 121.71,
    height: 87.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 496.39500000000004,
    y: 656.4200000000001
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 557.26,
    y: 450.54,
    width: 142.74,
    height: 76.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.872857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 628.63,
    y: 488.595
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 557.26,
    y: 526.65,
    width: 142.74,
    height: 77.63,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.4075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 628.63,
    y: 565.4649999999999
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 557.26,
    y: 604.27,
    width: 142.74,
    height: 95.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.96625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 628.63,
    y: 652.135
  }, "\n        Buncombe\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1904);
export default __webpack_public_path__ + "static/media/1904.5cea15a3e30475d6502604c4a1fe95f0.svg";
export { ForwardRef as ReactComponent };